import React from 'react';
import { COLLAPSED_MODE_MAX_ITEMS, useTreeCard } from '../TreeCard';
import Link from 'next/link';

export interface IListItem {
  label: string;
  url: string;
  dataTestId?: string;
  dataTestName?: string;
}
interface IListProps {
  list: IListItem[];
  dataTestId?: string;
}

export const List: React.FC<IListProps> = ({ list, dataTestId = '' }) => {
  const { isExpanded } = useTreeCard();
  const itemsToShow = list.slice(
    0,
    isExpanded ? list.length : COLLAPSED_MODE_MAX_ITEMS,
  );

  return (
    <div>
      <ul aria-expanded={isExpanded} data-testid={dataTestId}>
        {itemsToShow.map(
          ({ label, url, dataTestId = '', dataTestName = '' }, index) => {
            return (
              <li
                key={index}
                className={`
                  tw-flex
                  tw-flex-row
                  tw-items-center
                  tw-border-0
                  tw-border-b
                  tw-border-solid
                  tw-border-blue-200
                `}
                data-testid={dataTestId}
                data-testname={dataTestName}
              >
                <Link
                  href={url}
                  title={label}
                  className="tw-flex tw-h-full tw-w-full tw-flex-col tw-justify-center"
                >
                  <span className="tw-lf-body-regular-md tw-mx-3 tw-my-4 tw-line-clamp-3">
                    {label}
                  </span>
                </Link>
              </li>
            );
          },
        )}
      </ul>
    </div>
  );
};
